module.exports = __webpack_public_path__ + "img/plan3.7edf69f.png";